import React from 'react';
import Card from './Card';

const CorePillars = () => {
    const pillars = [
        { icon: 'fa-lightbulb', title: 'Consulting & Advisory', desc: 'Strategic guidance for digital initiatives' },
        { icon: 'fa-code', title: 'Solution Development', desc: 'Custom software & platforms' },
        { icon: 'fa-robot', title: 'Automation & Hyper-Automation', desc: 'Intelligent process automation' },
        { icon: 'fa-flask', title: 'Innovation & POC Builds', desc: 'Rapid prototyping & validation' },
        { icon: 'fa-graduation-cap', title: 'Training & Capability', desc: 'Skills & knowledge transfer' }
    ];

    return (
        <section style={{ padding: '80px 0', backgroundColor: '#f9fafb' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <h2 style={{
                        fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                        fontWeight: 'bold',
                        color: '#0C1A36',
                        marginBottom: '16px'
                    }}>
                        Our Core Pillars
                    </h2>
                    <p style={{ color: '#4b5563', maxWidth: '600px', margin: '0 auto' }}>
                        Five integrated capabilities that drive your digital success
                    </p>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        backgroundColor: '#1746A2',
                        margin: '16px auto 0'
                    }}></div>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '24px'
                }}>
                    {pillars.map((pillar, index) => (
                        <Card
                            key={index}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '12px',
                                padding: '24px',
                                textAlign: 'center',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.07)',
                                border: '1px solid #f3f4f6'
                            }}
                        >
                            <div style={{
                                width: '56px',
                                height: '56px',
                                backgroundColor: 'rgba(23, 70, 162, 0.1)',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 16px'
                            }}>
                                <i className={`fas ${pillar.icon}`} style={{
                                    fontSize: '24px',
                                    color: '#1746A2'
                                }}></i>
                            </div>
                            <h3 style={{
                                fontWeight: 'bold',
                                color: '#0C1A36',
                                marginBottom: '8px',
                                fontSize: '16px'
                            }}>
                                {pillar.title}
                            </h3>
                            <p style={{ fontSize: '14px', color: '#4b5563' }}>
                                {pillar.desc}
                            </p>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CorePillars;